import React from 'react';
import { Play } from 'lucide-react';
import { isDevelopment } from "~/utils/env";
import { Tooltip as ReactTooltip } from "react-tooltip";

const TestButton = ({
    className,
    tooltip = 'Test Mode',
    onClick,
    position = 'bottom-right'
}) => {
    if (!isDevelopment()) return null;

    return (
        <div className={className}>
            <button
                data-tooltip-id="test-button-tooltip"
                data-tooltip-content={tooltip}
                onClick={onClick}
                className="flex items-center gap-2 px-4 py-2 rounded-[3px]
                    bg-gradient-to-b from-oil-20 to-oil-40
                    shadow-md hover:shadow-lg
                    border border-oil-30
                    transition-all duration-200
                    text-oil-dark"
            >
                <Play size={18} className="text-leaf-key"/>
                <span>Test</span>
            </button>

            <ReactTooltip
                id="test-button-tooltip"
                place={position}
                className="!bg-storm-70 !opacity-90"
                multiline={true}
                delayShow={200}
                variant="dark"
            />
        </div>
    );
}; 

export default TestButton;